@charset "UTF-8";

/* src/app/builder-screen-beta/inspector/search-dependency-modal.component.scss */
.dep-modal__header {
  margin-bottom: 16px;
}
.dep-modal__header h3 {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
}
.dep-modal__header p {
  margin: 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  line-height: 1.6;
}
.dep-modal__search {
  margin-bottom: 12px;
}
.dep-modal__body {
  max-height: 420px;
  overflow-y: auto;
  margin: 0 -4px;
  padding: 0 4px;
}
.dep-modal__body ::ng-deep .ant-collapse > .ant-collapse-item {
  border-bottom: none;
  margin-bottom: 4px;
}
.dep-modal__body ::ng-deep .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 6px 12px !important;
  border-radius: 6px;
  background: #fafafa;
  align-items: center;
}
.dep-modal__body ::ng-deep .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  font-size: 10px;
}
.dep-modal__body ::ng-deep .ant-collapse > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding: 6px 0 2px;
}
.dep-modal__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
.dep-modal__footer-info {
  margin-right: auto;
  font-size: 12px;
  color: #1890ff;
  font-weight: 500;
}
.dep-group-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.dep-group-title__tag {
  margin: 0;
  font-size: 11px;
  line-height: 18px;
}
.dep-group-title__count {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
}
.dep-group-title__count::before {
  content: "\b7   ";
}
.dep-group-title__count::after {
  content: " campo(s)";
}
.dep-item {
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  margin-bottom: 4px;
  transition: all 0.2s;
}
.dep-item:hover {
  border-color: #d9d9d9;
}
.dep-item--active {
  border-color: #91d5ff;
  background: #f0f9ff;
}
.dep-item__row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dep-item__row label[nz-checkbox] {
  flex: 1;
  min-width: 0;
}
.dep-item__label {
  font-size: 13px;
  font-weight: 500;
}
.dep-item__path {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.04);
  padding: 1px 6px;
  border-radius: 3px;
  white-space: nowrap;
  flex-shrink: 0;
}
.dep-item__config {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e8e8e8;
}
.dep-item__config nz-form-item {
  margin-bottom: 8px;
}
.dep-item__config ::ng-deep .ant-form-item-label > label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  height: auto;
}
.dep-item__optional {
  font-size: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.35);
  margin-left: 4px;
}
.dep-item__help-icon {
  margin-left: 4px;
  color: #1890ff;
  cursor: help;
  font-size: 12px;
}
.dep-item__clear {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}
/*# sourceMappingURL=search-dependency-modal.component.css.map */
